var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-card-private tool-tip"},[_c('iconic',{attrs:{"name":"user_lock"}}),_c('span',{staticClass:"tooltiptext tool-archive",attrs:{"noevents":""}},[_vm._v("Noticia Privada")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }